var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pt-3",attrs:{"color":"transparent","flat":""}},[_c('vue-headful',{attrs:{"title":_vm.componentConfig.branding.title((_vm.canSeeNewUi ? 'Deals' : 'Markeplace') + ' Overview')}}),_c('dealsOverviewScreen',{attrs:{"isOverview":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }